import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const AudienceIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 32 33" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="ka1ldfv9aa">
          <path d="M600 0v840H0V0h600z" />
        </clipPath>
        <clipPath id="l0nf6kwfgb">
          <path d="M11.652 0c4.022 0 7.283 3.248 7.283 7.255a7.127 7.127 0 0 1-2.476 5.398 11.606 11.606 0 0 1 6.845 10.563c0 .801-.652 1.45-1.456 1.45-.805 0-1.457-.649-1.457-1.45 0-4.808-3.912-8.706-8.739-8.706-4.826 0-8.739 3.898-8.739 8.706 0 .801-.652 1.45-1.456 1.45-.805 0-1.457-.649-1.457-1.45a11.606 11.606 0 0 1 6.846-10.563A7.127 7.127 0 0 1 4.37 7.255C4.37 3.248 7.63 0 11.652 0zm8.74 0a7.284 7.284 0 0 1 6.644 4.28 7.233 7.233 0 0 1-1.197 7.792 13.047 13.047 0 0 1 6.16 11.144c0 .801-.651 1.45-1.456 1.45-.804 0-1.456-.649-1.456-1.45a10.154 10.154 0 0 0-5.826-9.258l-.19-.101-.568-.377a1.45 1.45 0 0 1-.655-1.248 1.45 1.45 0 0 1 .728-1.22 4.35 4.35 0 0 0 2.185-3.757c0-2.404-1.956-4.353-4.37-4.353-.804 0-1.456-.65-1.456-1.451S19.587 0 20.39 0zm-8.74 2.902c-2.413 0-4.37 1.949-4.37 4.353s1.957 4.353 4.37 4.353c1.16 0 2.27-.459 3.09-1.275a4.345 4.345 0 0 0 1.28-3.078c0-2.404-1.957-4.353-4.37-4.353z" />
        </clipPath>
      </defs>
      <g clipPath="url(#ka1ldfv9aa)" transform="translate(-32 -690)">
        <g clipPath="url(#l0nf6kwfgb)" transform="translate(32 694.5)">
          <path d="M0 0h32v24.667H0V0z" />
        </g>
      </g>
    </svg>
  )
})
